import { useMemo } from 'react';

import { TextField } from '@mui/material';
import { FieldValues, useController, UseControllerProps } from 'react-hook-form';

import { EditableRowsTable } from 'components';
import strings from 'constants/index';
import { NameColumn } from 'utils/table.utils';

interface WithItemsValues extends FieldValues {
  items?: Array<Entity & EditableItem>;
}

export function AliasFormField<T extends WithItemsValues>({
  name,
  control,
  required,
}: UseControllerProps<T> & { required?: boolean }) {
  const {
    field: { onChange, value: items },
  } = useController<T>({
    name,
    control,
    rules: {
      required: { value: required, message: strings.field_is_required },
    },
  });

  const defaultValue = useMemo(() => items.find((el: StringEditableItem) => el.active), [items]);

  const columns = [
    {
      ...NameColumn,
      id: 'value',
      editControl: (
        <TextField
          variant="standard"
          id={name}
          data-testid={name}
          size="small"
          defaultValue={defaultValue?.id ? defaultValue.value : null}
          onChange={(item: any) => {
            if (item && !items.some(el => el.id === item.id)) {
              const itemIdx = items.findIndex(el => el.active);
              if (itemIdx !== -1) {
                const newItem = {
                  ...items[itemIdx],
                  id: `new-${itemIdx}`,
                  value: item.target.value,
                };
                const newItems = [...items];
                newItems[itemIdx] = newItem;
                onChange(newItems);
              }
            }
          }}
          fullWidth
          required={required}
          autoFocus
        />
      ),
    },
  ];

  return <EditableRowsTable items={items} columns={columns} onSave={onChange} headerHidden />;
}
